<template>
    <v-container class="grey lighten-5" fluid>
        <v-row>
            <v-col md="8" offset-md="2">
                <v-card>
                    <v-card-title class="px-3">Add Client</v-card-title>
                    <v-divider></v-divider>
                    
                        <v-form ref="form" lazy-validation @submit="onSubmit">
                            <div class="px-4 py-0 add-client-container">
                                <v-row>
                                    <v-col md="6">
                                        <v-autocomplete
                                            v-model="form.merchantId"
                                            label="Select a merchant"
                                            :items="merchants"
                                            item-value="merchantId"
                                            item-text="merchantName"
                                            dense
                                            clearable
                                            :rules="[rules.required]"
                                            @change="updateMerchantId(form.merchantId)"
                                            @clear="clearMerchantId()"
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col md="6">
                                        <v-text-field
                                            v-model="form.firstName"
                                            :rules="[rules.required]"
                                            label="First Name"
                                            maxlength="32"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="6" class="pt-0">
                                        <v-text-field
                                            v-model="form.surname"
                                            :rules="[rules.required]"
                                            label="Surname"
                                            maxlength="32"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="6" class="pt-0">
                                        <v-text-field
                                            v-model="form.merchantCustomerId"
                                            :rules="[rules.required, dupeReference]"
                                            label="Reference"
                                            maxlength="32"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="6" class="pt-0">
                                        <v-text-field
                                            v-model="form.email"
                                            label="Email"
                                            maxlength="128"
                                            required
                                            :rules="[validEmail]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="6" class="pt-0">
                                        <v-text-field
                                            v-model="form.mobile"
                                            label="Mobile"
                                            maxlength="15"
                                            required
                                            :rules="[mobileCheck]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="6" class="pt-0">
                                        <v-text-field
                                            v-model="form.street1"
                                            :rules="[rules.required]"
                                            label="Street 1"
                                            maxlength="32"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="6" class="pt-0">
                                        <v-text-field
                                            v-model="form.street2"
                                            label="Street 2"
                                            maxlength="32"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="6" class="pt-0">
                                        <v-text-field
                                            v-model="form.city"
                                            :rules="[rules.required]"
                                            label="City"
                                            maxlength="32"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="6" class="pt-0">
                                        <v-text-field
                                            v-model="form.postcode"
                                            :rules="[rules.required]"
                                            label="Postcode"
                                            maxlength="7"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="6" class="pt-0">
                                        <v-menu
                                        ref="clientDobMenu"
                                        v-model="dobField.dialogue.menu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                        >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                            v-model="form.dob"
                                            label="Date of Birth"
                                            readonly
                                            clearable
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules="dobField.rules"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="form.dob"
                                            :active-picker.sync="dobField.dialogue.activePicker"
                                            :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                                            min="1950-01-01"
                                            @change="save"
                                        ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </div>

                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" type="submit">Add Client</v-btn>
                            </v-card-actions>
                        </v-form>
                </v-card>

                <v-row v-if="result">
                    <v-col md="12">
                        <v-alert type="success" text border="left" dismissible>
                            {{ result }}
                        </v-alert>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    beforeMount() {
        this.getMerchants();
        this.getClients();
    },
    data() {
        return {
            rules: {
                required: v => !!v || 'Required.'
            },
            form: {
                merchantId: null, 
                merchantCustomerId: null,
                firstName: null,
                surname: null,
                email: null,
                mobile: null,
                street1: null,
                street2: null,
                city: null,
                postcode: null,
                dob: null,
            },
            dobField: {
                required: false,
                rules: [],
                dialogue: {
                    activePicker: null,
                    menu: false,
                },
            },
            merchants: [],
            result: null,
            clients: []
        }
    },
    watch: {
        "dobField.dialogue.menu" (val) {
            val && setTimeout(() => (this.dobField.dialogue.activePicker = 'YEAR'))
        },
        "dobField.required" (required) {
            if (required) {
                this.dobField.rules = [this.rules.required];
            } else {
                this.dobField.rules = [];
            }
        },
    },
    methods: {
        save (date) {
            this.$refs.clientDobMenu.save(date)
        },
        clearMerchantId() {
            this.dobField.required = false;
        },
        updateMerchantId(merchantUuid) {
            if (merchantUuid == null || merchantUuid == "") {
                this.dobField.required = false;
                return;
            } 

            var merchant = this.merchants.find(obj => {
                return obj.merchantId === merchantUuid
            })

            if (typeof merchant === 'undefined') {
                this.dobField.required = false;
                return;
            }

            if (typeof merchant.captureDob === 'undefined') {
                this.dobField.required = false;
                return;
            }

            var captureDob = Boolean(merchant.captureDob);
            this.dobField.required = captureDob;
        },
        getMerchants() {
            if(this.$store.state.user.user_role.id <= 3) {
                axios({
                method: 'get',
                url: `get-crm-merchants-live`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(response.data);
                    this.merchants = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else if(this.$store.state.user.user_role.id > 3) {
                axios({
                method: 'post',
                url: `get-crm-merchants-live-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        onSubmit(e) {
            e.preventDefault();

            if(this.$refs.form.validate()) {
                axios({
                method: 'post',
                data: { client: this.form, userId: this.$store.state.user.id },
                url: 'add-client',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    if(response.status == 201) {
                        this.result = "Client successfully added."
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getClients() {
            axios({
            method: 'get',
            url: 'get-all-clients',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.clients = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        dupeReference(e) {
            return !this.clients.some(c => c.merchantCustomerId.toLowerCase() === e.toLowerCase()) || 'Reference already exists.';
        },
        mobileCheck(e) {
            if(e) {
                // Allow UK and international numbers (e.164 format)

                // If length is 0 return true
                if (e.length == 0){
                    return true;
                }

                // If length is 11 and starts with a 0 return true
                if (e.length == 11 && e.startsWith('07')){
                    return true;
                }

                // If match e.164 format return true
                var re = new RegExp("^[+][1-9][0-9]{1,14}$");
                if (re.test(e)) {
                    return true;
                }

                // If here, then return invalid phone number
                return 'Invalid mobile number';
            }
            else {
                return true;
            }
        },
        validEmail(e)  {
            if(e) {
                let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(e) || e.length == 0 ? true : 'Invalid email address.';
            }
            else {
                return true;
            }
        },
    }
}
</script>

<style>
    .add-client-container .v-text-field.v-input--dense {
        padding-top: 12px;
    }
</style>